import Notify from 'quasar/src/plugins/Notify.js';;
export function notify(message, caption, type, color) {
  Notify.create({
    classes: 'text-weight-bold text-center',
    actions: [{
      color: 'white',
      icon: 'close'
    }],
    caption: caption,
    color: color || type || 'grey-10',
    message: message,
    position: 'top',
    icon: type === 'negative' ? 'report_problem' : type === 'positive' ? 'thumb_up' : ''
  });
}